import { createClient } from '@supabase/supabase-js'

// Use the correct project URL and anon key
const SUPABASE_URL = 'https://aqecrwfaqglfrnqlzrzh.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFxZWNyd2ZhcWdsZnJucWx6cnpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk0NzEyOTIsImV4cCI6MjA2NTA0NzI5Mn0.uP0CAV9sOO2WWc4ilbwjk3gbEGiOMsqYms3cegUeSdM'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase